/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { slicedToArray as _slicedToArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { createContext, useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';

var Context = /*#__PURE__*/createContext();
Context.displayName = 'DataHookMockContext';
var getParam = function getParam(name) {
  var n = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp("[\\?&]".concat(n, "=([^&#]*)"));
  var results = regex.exec(window.location.search);
  return results === null || results[1] === 'undefined' ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};
var Provider = function Provider(_ref) {
  var enableAutoMocking = _ref.enableAutoMocking,
    _ref$mock = _ref.mock,
    mock = _ref$mock === void 0 ? false : _ref$mock,
    children = _ref.children;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    mockFlag = _useState2[0],
    setMockFlag = _useState2[1];
  useEffect(function () {
    if (enableAutoMocking) setMockFlag(getParam('mock') === 'true');
  }, [enableAutoMocking]);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: mockFlag || mock
  }, children);
};
Provider.propTypes = {
  children: PropTypes.node.isRequired,
  enableAutoMocking: PropTypes.bool,
  mock: PropTypes.bool
};
var useDataHookMock = function useDataHookMock() {
  return useContext(Context);
};
var DataHookMock = {
  Context: Context,
  Provider: Provider,
  useDataHookMock: useDataHookMock
};

export { DataHookMock as default };
